
//used for filter, load more click, and product recommendation section
function rebindCartEvents() {

// <------------------------ Open Ajax cart -------------------->

// product page frequently bought toghether product script
 $(".frequently-btn").off("click").on("click", function () {
   const item = $(this);
   var upselID = $(this).attr("data-id");
   const sQty = parseInt($(item).attr('data-qty'));

  var get_data = {
    items: [
      {
        quantity: 1,
        id: upselID
      }
    ]
  };

  // ------------- AJAX code for adding to cart -----------
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: get_data,
    success: function (data) {

      // Emit event to update the cart (Reformation theme might use these events)
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: data } }));
        $(item).attr('data-qty',(sQty - 1));
        console.log('sQty ',sQty);
        $("#refresh-cart").trigger("click"); 
      
      // Call function to open AJAX cart
      setTimeout(function () {
       updateAjaxCart();
       }, 400);
      // Fetch latest cart data and trigger refresh event
      // setTimeout(function () {
      //   $.getJSON('/cart.js', function (cart) {
      //     let cartData = cart.items;
      //     document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cartData }));
      //   });
      // }, 100);         
      
    },
    error: function (error) {
      // console.error('Error adding to cart:', error);
      // console.log(error);          
      
    }
  });
});

// Function to open and refresh AJAX cart
function updateAjaxCart() {

  const ajaxCart = document.getElementById('Cart-Drawer');
  if (ajaxCart) {
    ajaxCart.classList.add('active'); // Open the cart drawer
    document.dispatchEvent(new Event('cart:updated')); // Reformation theme cart refresh event
  } else {
    console.log('AJAX cart not found.');
  }
}


$(document).off("click", "#refresh-cart").on("click", "#refresh-cart", function () {
  $.getJSON('/cart.js', function (cart) {

    // Dispatch event to update the cart UI
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    // Update cart count (modify the selector if your theme uses a different one)
    $(".thb-item-count").text(cart.item_count);

    // Optional: Force reload cart content inside the drawer
    reloadCartDrawer(cart);
  });
});

// Function to force reload cart content inside the cart drawer
function reloadCartDrawer(cart) {
  $("#Cart-Drawer").load(location.href + " #Cart-Drawer > *", function () {
  });
}

// <------------------------ End Ajax cart -------------------->

}


// ajax cart
rebindCartEvents();




// index page review slider
$('.review-slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// index page winter-poster-slider
$('.winter-poster-slider').slick({
  infinite: true,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1
});


// index page products-collection-slider
function initProductSlider() {
  $('.index-products-collection-slider').each(function() {
    var $slider = $(this);
    
    // Destroy existing slider if it exists
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    
    // Initialize slider
    $slider.slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 2,
      prevArrow: '<div class="slick-prev"><svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33333 3L20 20L3.33333 37" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      nextArrow: '<div class="slick-next"><svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6667 3L3 20L19.6667 37" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}

// Initialize on page load
$(document).ready(function() {
  initProductSlider();
});

// Reinitialize when theme editor changes the section
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  $(document).on('shopify:section:load', function(event) {
    setTimeout(function() {
      initProductSlider();
    }, 10);
  });
}


// index page learn-slider
$('.learn-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.vdo-btn-click').click(function(){
  $(this).parent().parent(".thumb-btn-wrap").hide().addClass("vid-is-show");
  $(this).parent().parent().siblings(".vdo-sec").children("#vdo-play").trigger('play');
});



//faq page  and product page tab script
  $(".cmn-tab").click(function(){
      // tab menu active class add
       $(this).addClass("active");
       $(this).siblings().removeClass("active");

       // tab content active class add
       let tabId = $(this).attr("data-id");

        $(this).parent().next().children().each(function(){
           let TabcontId = $(this).attr("data-id");
            if (tabId == TabcontId){
               $(this).show();
               $(this).addClass("active");
               $(this).siblings().hide();
               $(this).siblings().removeClass("active");
            }          
        });
       
    });

    
  $(".faq-heading").click(function () {
    $(this).parent(".faq-block-items").toggleClass("active");
    $(this).next(".faq-text").slideToggle();
     $(this).parent(".faq-block-items").siblings().removeClass("active");
     $(this).parent(".faq-block-items").siblings().find(".faq-text").slideUp();
  });



// product page product image load more script
$(function() {
  const $productSlider = $('#Product-Slider');
  const desktopLoadMore = $productSlider.attr('data-desktop-load-more') === 'true';
  const mobileLimit = $productSlider.attr('data-mobile-limit');
  
  function getInitialCount() {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      if (mobileLimit === 'all') {
        return $(".cus-product-image").length;
      } else {
        return parseInt(mobileLimit) || 4;
      }
    } else {
      if (!desktopLoadMore) {
        return $(".cus-product-image").length;
      } else {
        return 4;
      }
    }
  }

  function updateImages() {
    const initialCount = getInitialCount();
    $(".cus-product-image").hide().slice(0, initialCount).show();
    if ($(".cus-product-image:hidden").length === 0) {
      $("#load").hide();
    } else {
      $("#load").show();
    }
  }

  // Initial setup
  updateImages();

  $("#load").off('click').on('click', function(e) {
    e.preventDefault();
    $(".cus-product-image:hidden").slice(0, 4).show();
    if ($(".cus-product-image:hidden").length === 0) {
      $("#load").hide();
    }
  });

  // Responsive update without reload
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      updateImages();
    }, 250);
  });
});


// Place wishlist and quality feature button in same alignment
$(function () {
  function placeWishlistBeforeQualityFeature() {
    var $qualityBtn = $('.qualityFeatureMdl').first();
    var $wishlistBtn = $('.swym-wishlist-button-bar').first();

    if ($qualityBtn.length && $wishlistBtn.length && !$wishlistBtn.next('.qualityFeatureMdl').length) {
      // Create flex container if not already present
      var $flexDiv = $('<div class="wishlist-quality-flex"></div>').css({
        display: 'flex',
        gap: '12px',
        alignItems: 'center'
      });

      // Insert flex container before quality button
      $qualityBtn.before($flexDiv);

      $flexDiv.append($wishlistBtn);
      $flexDiv.append($qualityBtn);
    }
  }

  placeWishlistBeforeQualityFeature();

  // Observe DOM changes for dynamic loading (Swym)
  var observer = new MutationObserver(function () {
    placeWishlistBeforeQualityFeature();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});






// Collection page 
let Colllabel = document.querySelectorAll(".custom-coll-label");

Colllabel.forEach(label => {
   label.addEventListener("click", function(){
     this.parentElement.classList.toggle("active");
   });
});



//about page season slider
var swiper = new Swiper(".mySwiper", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
});

//about page season slider
 var swiper = new Swiper(".promySwiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });



// product page 
$(".template-page-sitemap .SectionHeader__Heading").each(function(a) {
     $(this).addClass("prd-itm-no-"+(a+0));
});
$(".template-page-sitemap .SectionHeader__Heading ~ ul").each(function(b) {
     $(this).addClass("prd-itm-no-"+(b+0));
});
$(".prd-itm-no-0").wrapAll('<div class="prd-wrap-col prd-0"></div>');
$(".prd-itm-no-1").wrapAll('<div class="prd-wrap-col prd-1"></div>');
$(".prd-itm-no-2").wrapAll('<div class="prd-wrap-col prd-2"></div>');
$(".prd-itm-no-3").wrapAll('<div class="prd-wrap-col prd-3"></div>');


// filter stock
// if(!document.querySelector('input[name="filter.v.availability"]:checked') && document.querySelector('input[name="filter.v.availability"]')){
//   document.querySelector('input[name="filter.v.availability"]').click();    
// }

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 1067) {
    document.querySelector(".custom-coll-wrap.active")?.classList.remove("active");
    document.querySelector(".custom-coll-wrap .thb-filter")?.removeAttribute("open");
  }
});
